import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: ${({ theme, $narrow }) =>
    $narrow ? theme.narrow : theme.maxWidth};
  margin: 0 auto;
  padding: 0 20px;

  ${({ theme }) => theme.bp.md} {
    padding: 0 40px;
  }
`;

export const Section = styled.section`
  padding: ${({ $tight }) => ($tight ? "64px 0" : "88px 0")};
  position: relative;

  ${({ theme }) => theme.bp.md} {
    padding: ${({ $tight }) => ($tight ? "88px 0" : "136px 0")};
  }

  ${({ $alt, theme }) =>
    $alt &&
    css`
      background: ${theme.colors.bgAlt};
    `}
`;

export const Eyebrow = styled.span`
  display: inline-block;
  font-size: ${({ theme }) => theme.size.xs};
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-weight: 500;
  color: ${({ theme, $color }) => $color || theme.colors.inkFaint};
  margin-bottom: 18px;
`;

export const Lead = styled.p`
  font-size: ${({ theme }) => theme.size.lg};
  color: ${({ theme }) => theme.colors.inkSoft};
  line-height: 1.6;
  max-width: 56ch;
`;

const buttonBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 15px 30px;
  border-radius: ${({ theme }) => theme.radius.pill};
  font-size: ${({ theme }) => theme.size.sm};
  font-weight: 500;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: transform 0.35s ${({ theme }) => theme.ease},
    background 0.35s ease, color 0.35s ease, box-shadow 0.35s ease,
    border-color 0.35s ease;
  will-change: transform;

  &:hover {
    transform: translateY(-2px);
  }
  &:active {
    transform: translateY(0);
  }
`;

export const Button = styled.button`
  ${buttonBase};
  background: ${({ theme, $color }) => $color || theme.colors.brand};
  color: #fff;
  box-shadow: ${({ theme }) => theme.shadow.soft};

  &:hover {
    box-shadow: ${({ theme }) => theme.shadow.lift};
  }
`;

export const ButtonLink = styled.a`
  ${buttonBase};
  background: ${({ theme, $color }) => $color || theme.colors.brand};
  color: #fff;
  box-shadow: ${({ theme }) => theme.shadow.soft};

  &:hover {
    box-shadow: ${({ theme }) => theme.shadow.lift};
  }
`;

export const GhostLink = styled.a`
  ${buttonBase};
  background: transparent;
  color: ${({ theme, $color }) => $color || theme.colors.ink};
  border: 1px solid ${({ theme }) => theme.colors.line};

  &:hover {
    border-color: ${({ theme, $color }) => $color || theme.colors.ink};
  }
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.line};
  border-radius: ${({ theme }) => theme.radius.lg};
  padding: 32px;
`;
